import type { IDocument } from "@bbj-types/document";
import type { ObjectId } from "@bbj-types/utils";
import { useCallback } from "react";
import { axios } from "./axios";

export interface IGenerateCvResponse {
  document: IDocument;
  url: string;
}

export const useGenerateCV = () => {
  const [state, execute, cancel] = axios<IGenerateCvResponse, void, unknown>(
    {
      method: "GET",
      url: "/generateCv",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(
    (candidateId: ObjectId) => {
      return execute({
        params: {
          candidateId,
        },
      });
    },
    [execute]
  );

  return [state, callback, cancel] as const;
};
